import { render, staticRenderFns } from "./NewPlan.vue?vue&type=template&id=2a15bcc0&scoped=true&"
import script from "./NewPlan.vue?vue&type=script&lang=js&"
export * from "./NewPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a15bcc0",
  null
  
)

export default component.exports